import Backbone from "backbone";
import inject from "scripts/ioc/inject";
import BaseMediaSalvattoreTileView from "scripts/views/baseMediaSalvattoreTileView";

import templateVideoSalvattoreTile from "templates/videoSalvattoreTile.hbs";

const chan = Backbone.Radio.channel;

class VideoSalvattoreTileView extends BaseMediaSalvattoreTileView {
  constructor(options, securityService = inject("securityService")) {
    super(options, securityService);
  }

  get template() {
    return templateVideoSalvattoreTile;
  }

  onClickViewer() {
    if (this.model.has("referringParent")) {
      this.saveReferringParent();
    }

    chan("display").request("playVideo", this.model);
    chan("tracking").trigger("viewer:click", this.model);
    return false;
  }
}

export default VideoSalvattoreTileView;
